import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {postJSONPromise} from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface ExportDataFrameAsCSVResponse {
  fileName: string;
  url: string;
}

export function exportDataFrameAsCSV(dataFrameId: string): Promise<ExportDataFrameAsCSVResponse> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/data-frames/${dataFrameId}/export-csv`,
  });
}

// The backend requires exactly one source: copy from a dataset's backing data frame, or from an existing
// data frame. See data_frame_rest_specs.py.
export type CreateDataFrameParams = {name: string; datasetId: string} | {name: string; dataFrameId: string};

export interface CreateDataFrameResponse {
  createdIds: Array<string>;
}

export function createDataFrame(params: CreateDataFrameParams): Promise<CreateDataFrameResponse> {
  const creates = [params];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.DATA_FRAME), data: {creates}});
}
